export enum IProgressStatusEnum {
  NONE = '',
  ESTIMATE_SENT = 'sent',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
}
